(function () {
  var SECTION_SELECTOR = '.oddit-header';
  var header = document.querySelector(SECTION_SELECTOR);
  if (!header) return;

  function syncHeaderHeight() {
    var h = header.offsetHeight + 'px';
    header.style.setProperty('--oddit-header-height', h);
    // Mirror on :root so siblings (e.g. the search drawer) can read it.
    document.documentElement.style.setProperty('--oddit-header-height', h);
  }
  syncHeaderHeight();
  window.addEventListener('resize', syncHeaderHeight);
  if (window.ResizeObserver) {
    new ResizeObserver(syncHeaderHeight).observe(header);
  }

  var megaMenu = header.querySelector('[data-mega-menu-panel]');
  var overlay = header.querySelector('[data-header-overlay]');
  var mobileMenu = header.querySelector('#oddit-header-mobile-menu');
  var menuToggle = header.querySelector('.oddit-header__menu-toggle');
  var mobileClose = header.querySelector('[data-mobile-menu-close]');
  var megaMenuTriggers = header.querySelectorAll('[data-mega-menu-trigger]');
  var megaMenuContents = megaMenu ? megaMenu.querySelectorAll('[data-mega-menu-label]') : [];

  var activeTrigger = null;

  function openMegaMenu(trigger) {
    if (!megaMenu) return;
    var label = trigger.getAttribute('data-mega-menu-label');

    for (var i = 0; i < megaMenuContents.length; i++) {
      var content = megaMenuContents[i];
      if (content.getAttribute('data-mega-menu-label') === label) {
        content.style.display = '';
      } else {
        content.style.display = 'none';
      }
    }

    megaMenu.classList.add('is-open');
    megaMenu.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    header.classList.add('oddit-header--mega-open');

    if (overlay) {
      overlay.classList.add('is-visible');
    }

    activeTrigger = trigger;
  }

  function closeMegaMenu() {
    if (!megaMenu) return;
    megaMenu.classList.remove('is-open');
    megaMenu.setAttribute('aria-hidden', 'true');
    header.classList.remove('oddit-header--mega-open');

    for (var i = 0; i < megaMenuTriggers.length; i++) {
      megaMenuTriggers[i].setAttribute('aria-expanded', 'false');
    }

    if (overlay) {
      overlay.classList.remove('is-visible');
    }

    activeTrigger = null;
  }

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('oddit-header-menu-open');

    if (menuToggle) {
      menuToggle.setAttribute('aria-expanded', 'true');
    }
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('oddit-header-menu-open');
    closeAllMobileSubmenus(null);

    if (menuToggle) {
      menuToggle.setAttribute('aria-expanded', 'false');
    }
  }

  var mobileSubmenuTriggers = mobileMenu
    ? mobileMenu.querySelectorAll('[data-mobile-submenu-trigger]')
    : [];

  function getMobileSubmenuPanel(id) {
    if (!mobileMenu || !id) return null;
    return mobileMenu.querySelector('[data-mobile-submenu="' + id + '"]');
  }

  function closeAllMobileSubmenus(except) {
    for (var i = 0; i < mobileSubmenuTriggers.length; i++) {
      var trigger = mobileSubmenuTriggers[i];
      if (trigger === except) continue;
      var panel = getMobileSubmenuPanel(trigger.getAttribute('data-mobile-submenu-trigger'));
      trigger.setAttribute('aria-expanded', 'false');
      if (panel) {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      }
    }
  }

  for (var i = 0; i < megaMenuTriggers.length; i++) {
    (function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (activeTrigger === trigger) {
          closeMegaMenu();
        } else {
          openMegaMenu(trigger);
        }
      });

      trigger.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        openMegaMenu(trigger);
      });
    })(megaMenuTriggers[i]);
  }

  if (megaMenu) {
    megaMenu.addEventListener('mouseenter', function () {
      if (activeTrigger) {
        megaMenu.classList.add('is-open');
      }
    });

    megaMenu.addEventListener('mouseleave', function () {
      closeMegaMenu();
    });

    var navBar = header.querySelector('.oddit-header__nav');
    if (navBar) {
      navBar.addEventListener('mouseleave', function (e) {
        var relatedTarget = e.relatedTarget;
        if (relatedTarget && megaMenu.contains(relatedTarget)) return;
        closeMegaMenu();
      });
    }
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      if (mobileMenu && mobileMenu.classList.contains('is-open')) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });
  }

  if (mobileClose) {
    mobileClose.addEventListener('click', function () {
      closeMobileMenu();
    });
  }

  for (var s = 0; s < mobileSubmenuTriggers.length; s++) {
    (function (trigger) {
      trigger.addEventListener('click', function () {
        var id = trigger.getAttribute('data-mobile-submenu-trigger');
        var panel = getMobileSubmenuPanel(id);
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          trigger.setAttribute('aria-expanded', 'false');
          if (panel) {
            panel.classList.remove('is-open');
            panel.setAttribute('aria-hidden', 'true');
          }
        } else {
          closeAllMobileSubmenus(trigger);
          trigger.setAttribute('aria-expanded', 'true');
          if (panel) {
            panel.classList.add('is-open');
            panel.setAttribute('aria-hidden', 'false');
          }
        }
      });
    })(mobileSubmenuTriggers[s]);
  }

  var simpleDropdownTriggers = header.querySelectorAll('[data-simple-dropdown-trigger]');

  function getSimpleDropdownPanel(label) {
    if (!label) return null;
    return header.querySelector('[data-simple-dropdown-panel="' + label + '"]');
  }

  function closeAllSimpleDropdowns(except) {
    for (var i = 0; i < simpleDropdownTriggers.length; i++) {
      var trigger = simpleDropdownTriggers[i];
      if (trigger === except) continue;
      var panel = getSimpleDropdownPanel(trigger.getAttribute('data-simple-dropdown-label'));
      trigger.setAttribute('aria-expanded', 'false');
      if (panel) {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      }
    }
  }

  function openSimpleDropdown(trigger) {
    var label = trigger.getAttribute('data-simple-dropdown-label');
    var panel = getSimpleDropdownPanel(label);
    // Close the mega menu (only one nav surface open at a time).
    closeMegaMenu();
    closeAllSimpleDropdowns(trigger);
    if (panel) {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
    }
    trigger.setAttribute('aria-expanded', 'true');
  }

  function closeSimpleDropdown(trigger) {
    var label = trigger.getAttribute('data-simple-dropdown-label');
    var panel = getSimpleDropdownPanel(label);
    if (panel) {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    }
    trigger.setAttribute('aria-expanded', 'false');
  }

  /* Short close delay + panel-aware hover so quick mouse movements
     between the trigger and the dropdown panel don't dismiss it. */
  var simpleDropdownCloseTimer = null;

  function scheduleSimpleDropdownClose(trigger) {
    if (simpleDropdownCloseTimer) clearTimeout(simpleDropdownCloseTimer);
    simpleDropdownCloseTimer = setTimeout(function () {
      closeSimpleDropdown(trigger);
      simpleDropdownCloseTimer = null;
    }, 200);
  }

  function cancelSimpleDropdownClose() {
    if (simpleDropdownCloseTimer) {
      clearTimeout(simpleDropdownCloseTimer);
      simpleDropdownCloseTimer = null;
    }
  }

  for (var d = 0; d < simpleDropdownTriggers.length; d++) {
    (function (trigger) {
      var wrapper = trigger.closest('.oddit-header__link-wrapper');
      var panel = getSimpleDropdownPanel(trigger.getAttribute('data-simple-dropdown-label'));

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closeSimpleDropdown(trigger);
        } else {
          openSimpleDropdown(trigger);
        }
      });

      if (wrapper) {
        wrapper.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse') return;
          cancelSimpleDropdownClose();
          openSimpleDropdown(trigger);
        });

        wrapper.addEventListener('pointerleave', function (e) {
          if (e.pointerType !== 'mouse') return;
          scheduleSimpleDropdownClose(trigger);
        });
      }

      if (panel) {
        panel.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse') return;
          cancelSimpleDropdownClose();
        });

        panel.addEventListener('pointerleave', function (e) {
          if (e.pointerType !== 'mouse') return;
          scheduleSimpleDropdownClose(trigger);
        });
      }
    })(simpleDropdownTriggers[d]);
  }

  // Opening the mega menu should close any simple dropdown.
  for (var t = 0; t < megaMenuTriggers.length; t++) {
    megaMenuTriggers[t].addEventListener('pointerenter', function () {
      closeAllSimpleDropdowns(null);
    });
  }

  // Hovering a plain nav link (no mega menu and no simple dropdown) should close
  // an open mega menu. Mega triggers switch panels and simple-dropdown triggers
  // already close it via openSimpleDropdown(); without this, moving from a mega
  // item to a plain one leaves the mega menu stuck open.
  var plainNavLinks = header.querySelectorAll(
    '.oddit-header__link:not([data-mega-menu-trigger]):not([data-simple-dropdown-trigger])'
  );
  for (var pl = 0; pl < plainNavLinks.length; pl++) {
    plainNavLinks[pl].addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      closeMegaMenu();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function () {
      closeMegaMenu();
      closeMobileMenu();
      closeAllSimpleDropdowns(null);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMegaMenu();
      closeMobileMenu();
      closeAllSimpleDropdowns(null);
    }
  });

  var cartToggles = header.querySelectorAll('[data-cart-toggle]');
  for (var i = 0; i < cartToggles.length; i++) {
    cartToggles[i].addEventListener('click', function () {
      if (window.OdditCartDrawer) {
        window.OdditCartDrawer.open();
      }
    });
  }

  var searchToggles = header.querySelectorAll('[data-search-toggle]');
  for (var i = 0; i < searchToggles.length; i++) {
    searchToggles[i].addEventListener('click', function () {
      if (window.OdditSearchDrawer) {
        window.OdditSearchDrawer.open();
      }
    });
  }

  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail.cart;
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var j = 0; j < badges.length; j++) {
      badges[j].textContent = cart.item_count;
      badges[j].style.display = cart.item_count > 0 ? '' : 'none';
    }
  });
})();